module.exports = __webpack_public_path__ + "static/og-dcc0452ca3163aed96d56034c801cd61.png";